import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="relative overflow-hidden"
      style={{ backgroundColor: "var(--footer-bg)", color: "var(--footer-text)" }}
      data-testid="site-footer"
      id="contact"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <p className="overline opacity-60">Vind ons</p>
            <p className="font-serif text-3xl md:text-4xl font-light leading-tight mt-4">
              Noordstraat&nbsp;140
              <br />
              <span className="opacity-70">8800 Roeselare, BE</span>
            </p>
            <p className="mt-8 text-sm opacity-70 leading-relaxed max-w-sm">
              Een huis voor ondernemers, creatievelingen en freelancers.
              Open van maandag tot vrijdag. Bezoek op afspraak van
              dinsdag tot vrijdag.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="overline opacity-60">Contact</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="mailto:liesbet@clementine.tv" className="hover:text-[var(--accent-soft)]" data-testid="footer-email">
                  liesbet@clementine.tv
                </a>
              </li>
              <li>
                <a href="tel:+32495629239" className="hover:text-[var(--accent-soft)]" data-testid="footer-phone">
                  +32 (0)495 62 92 39
                </a>
              </li>
              <li className="opacity-60 pt-3">
                <a
                  href="https://www.instagram.com/noordstraat140?igsh=YW9panF2ZHh6dzQy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-100 hover:text-[var(--accent-soft)] transition-opacity"
                  data-testid="footer-instagram"
                >
                  Instagram
                </a>
                {" · "}
                <span>LinkedIn</span>
              </li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <p className="overline opacity-60">Reserveren</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/book-desk" className="hover:text-[var(--accent-soft)]" data-testid="footer-link-desk">
                  → Boek een enkel bureau
                </Link>
              </li>
              <li>
                <Link to="/vergaderzalen" className="hover:text-[var(--accent-soft)]" data-testid="footer-link-meeting">
                  → Reserveer een vergaderzaal
                </Link>
              </li>
              <li>
                <Link to="/events" className="hover:text-[var(--accent-soft)]" data-testid="footer-link-event">
                  → Organiseer een event
                </Link>
              </li>
              <li>
                <Link to="/spaces/studio" className="hover:text-[var(--accent-soft)]" data-testid="footer-link-studio">
                  → Reserveer de studio
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-20 md:mt-28 select-none">
          <p
            className="font-serif font-light leading-[0.85] tracking-tighter"
            style={{ fontSize: "clamp(64px, 16vw, 260px)" }}
          >
            Noordstraat140.
          </p>
        </div>

        <div className="border-t mt-10 pt-6 text-xs flex flex-col md:flex-row justify-between gap-3 opacity-60"
             style={{ borderColor: "rgba(253,251,247,0.18)" }}>
          <span>© {new Date().getFullYear()} Noordstraat140. Alle rechten voorbehouden.</span>
          <span>Een huis voor werk, samen.</span>
        </div>
      </div>
    </footer>
  );
}
